<template>
  <div>
    <template v-if="field.type==='input'">
      <b-form-input size="sm" v-model="filter[field.key]" :debounce="filter.debounce" class="d-inline-block"/>
    </template>
    <template v-else-if="field.type==='select'">
      <v-select
          class="small"
          v-model="filter[field.key]"
          :options="field.props.options"
          :label="field.props.label"
          :reduce="field.props.reduce"
          :close-on-select="field.props.closeOnSelect|| false"
          :clearable="field.props.clearable || true"
          :multiple="field.props.multiple || false"
          :deselectFromDropdown="true"
          :placeholder="placeholder"
      />

    </template>
    <template v-else-if="field.type==='date'">
      <calendar-picker class="small" v-model="filter[field.key]" :label="$t(`filters.${field.label}`)" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='dateRange'">
      <calendar-picker-range class="small" v-model="filter[field.key]" :label="$t(`filters.${field.label}`)"
                             v-bind="field.props" :key="datePickerKey" :placeholder="placeholder"

      />
    </template>
    <template v-else-if="field.type==='tags'">
      <b-form-tags v-model="filter[field.key]" v-bind="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='checkbox'">
      <b-checkbox style="margin-top: 25px" v-model="filter[field.key]" v-bind="field.props" :placeholder="placeholder">
        <template v-if="field.noLabel !== false">{{ $t(`filters.${field.label}`) }}</template>
      </b-checkbox>
    </template>
    <template v-else-if="field.type==='dateTime'">
      <b-form-input class="d-inline-block" size="sm" type="date" :placeholder="placeholder"></b-form-input>
    </template>
    <template v-else-if="field.type==='number'">
      <b-form-input v-model="filter[field.key]" v-bind="field.props" class="d-inline-block" size="sm"
                    type="number" :placeholder="placeholder"
      ></b-form-input>
    </template>
    <template v-else-if="field.type==='checkboxGroup'" >
      <template v-for="f in field.fields">
        <b-checkbox inline style="margin-top: 25px" v-model="filter[f.key]" v-bind="f.props" v-bind:key="f.key">
          <template v-if="f.noLabel !== false">{{ $t(`filters.${f.label}`) }}</template>
        </b-checkbox>
      </template>
    </template>
    <!--Custom select boxes-->
    <template v-else-if="field.type==='department'">
      <departments-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"
                              v-bind:selected-business-unit="filter[organizationMap.bu]"
      />
    </template>
    <template v-else-if="field.type==='campaign'">
      <campaign-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"
                           v-bind:selected-business-unit="filter[organizationMap.bu]"
      />
    </template>
    <template v-else-if="field.type==='bu'">
      <business-unit-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props"
                                v-bind:selected-organization="filter[organizationMap.org]"
                                v-bind:selected-department="filter[organizationMap.dep]"
                                :placeholder="placeholder"
      />
    </template>
    <template v-else-if="field.type==='org'">
      <organization-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='affiliate'">
      <affiliate-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='smtpProvider'">
      <smtp-provider-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='activity'">
      <activity-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='monetaryStatus'">
      <monetary-status-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='monetaryAction'">
      <monetary-action-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='monetaryRealType'">
      <monetary-action-real-type-select-box class="small" v-model="filter[field.key]"
                                            v-bind:select-props="field.props" :placeholder="placeholder"
      />
    </template>
    <template v-else-if="field.type==='user'">
      <user-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='status'">
      <status-select-box class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>

    <template v-else-if="field.type==='clientId'">
      <client-picker class="small" v-model="filter[field.key]" v-bind:select-props="field.props" :placeholder="placeholder"/>
    </template>
    <template v-else-if="field.type==='accountPicker'">
      <account-picker ref="accountPicker" v-model="filter[field.key]" v-bind="field.props" multiple :placeholder="placeholder"/>
    </template>
  </div>
</template>
<script>
import MonetaryActionRealTypeSelectBox from '@/components/widget/select/type/monetaryActionRealTypeSelectBox.vue'
import MonetaryStatusSelectBox from '@/components/widget/select/MonetaryStatusSelectBox.vue'
import CalendarPickerRange from '@/components/widget/picker/calendarPickerRange.vue'
import OrganizationSelectBox from '@/components/widget/select/OrganizationSelectBox.vue'
import DepartmentsSelectBox from '@/components/widget/select/DepartmentsSelectBox.vue'
import BusinessUnitSelectBox from '@/components/widget/select/BusinessUnitSelectBox.vue'
import ClientPicker from '@/components/widget/picker/clientPicker.vue'
import SmtpProviderSelectBox from '@/components/widget/select/SmtpProviderSelectBox.vue'
import AffiliateSelectBox from '@/components/widget/select/AffiliateSelectBox.vue'
import UserSelectBox from '@/components/widget/select/UserSelectBox.vue'
import CalendarPicker from '@/components/widget/picker/calendarPicker.vue'
import CampaignSelectBox from '@/components/widget/select/CampaignSelectBox.vue'
import MonetaryActionSelectBox from '@/components/widget/select/MonetaryActionSelectBox.vue'
import ActivitySelectBox from '@/components/widget/select/ActivitySelectBox.vue'
import StatusSelectBox from '@/components/widget/select/StatusSelectBox.vue'
import AccountPicker from '@/components/widget/picker/accountPicker.vue'

export default {
  name: 'FilterCardFieldsTypePart',
  components: {
    AccountPicker,
    StatusSelectBox,
    ActivitySelectBox,
    MonetaryActionSelectBox,
    CampaignSelectBox,
    CalendarPicker,
    UserSelectBox,
    AffiliateSelectBox,
    SmtpProviderSelectBox,
    ClientPicker,
    BusinessUnitSelectBox,
    DepartmentsSelectBox,
    OrganizationSelectBox,
    CalendarPickerRange,
    MonetaryStatusSelectBox,
    MonetaryActionRealTypeSelectBox
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    organizationMap: {
      type: Object,
      required: true
    },
    placeholder:{
      type: String,
      default: ''
    }
  },
  computed: {
    filter: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
  }
}
</script>


<style scoped>

</style>